export const leafletDrawLocales = {
  en: {
    draw: {
      toolbar: {
        actions: {
          title: 'Cancel drawing',
          text: 'Cancel',
        },
        finish: {
          title: 'Finish drawing',
          text: 'Finish',
        },
        undo: {
          title: 'Delete last point drawn',
          text: 'Undo',
        },
        buttons: {
          polyline: 'Draw a polyline',
          polygon: 'Draw a polygon',
          rectangle: 'Draw a rectangle',
          circle: 'Draw a circle',
          marker: 'Place a marker',
          circlemarker: 'Place a circle marker',
        },
      },
      handlers: {
        circle: {
          tooltip: {
            start: 'Click and drag to draw circle.',
          },
          radius: 'Radius',
        },
        circlemarker: {
          tooltip: {
            start: 'Click map to place circle marker.',
          },
        },
        marker: {
          tooltip: {
            start: 'Click map to place marker.',
          },
        },
        polygon: {
          tooltip: {
            start: 'Click to start drawing shape.',
            cont: 'Click to continue drawing shape.',
            end: 'Click first point to close this shape.',
          },
        },
        polyline: {
          error: '<strong>Error:</strong> shape edges cannot cross!',
          tooltip: {
            start: 'Click to start drawing line.',
            cont: 'Click to continue drawing line.',
            end: 'Click last point to finish line.',
          },
        },
        rectangle: {
          tooltip: {
            start: 'Click and drag to draw rectangle.',
          },
        },
        simpleshape: {
          tooltip: {
            end: 'Release mouse to finish drawing.',
          },
        },
      },
    },
    edit: {
      toolbar: {
        actions: {
          save: {
            title: 'Save changes.',
            text: 'Save',
          },
          cancel: {
            title: 'Cancel editing, discards all changes.',
            text: 'Cancel',
          },
        },
        buttons: {
          edit: 'Edit layers',
          editDisabled: 'No layers to edit',
          remove: 'Delete layers',
          removeDisabled: 'No layers to delete',
        },
      },
      handlers: {
        edit: {
          tooltip: {
            text: 'Drag handles, or marker to edit feature.',
            subtext: 'Click cancel to undo changes.',
          },
        },
        remove: {
          tooltip: {
            text: 'Click on a feature to remove.',
          },
        },
      },
    },
  },

  ar: {
    draw: {
      toolbar: {
        actions: {
          title: 'إلغاء الرسم',
          text: 'إلغاء',
        },
        finish: {
          title: 'إنهاء الرسم',
          text: 'إنهاء',
        },
        undo: {
          title: 'حذف آخر نقطة',
          text: 'تراجع',
        },
        buttons: {
          polyline: 'رسم خط متعدد',
          polygon: 'رسم مضلع',
          rectangle: 'رسم مستطيل',
          circle: 'رسم دائرة',
          marker: 'إضافة علامة',
          circlemarker: 'إضافة علامة دائرية',
        },
      },
      handlers: {
        circle: {
          tooltip: {
            start: 'انقر واسحب لرسم دائرة.',
          },
          radius: 'نصف القطر',
        },
        circlemarker: {
          tooltip: {
            start: 'انقر على الخريطة لإضافة علامة دائرية.',
          },
        },
        marker: {
          tooltip: {
            start: 'انقر على الخريطة لإضافة علامة.',
          },
        },
        polygon: {
          tooltip: {
            start: 'انقر لبدء رسم الشكل.',
            cont: 'انقر للاستمرار في الرسم.',
            end: 'انقر على النقطة الأولى لإغلاق الشكل.',
          },
        },
        polyline: {
          error: '<strong>خطأ:</strong> لا يمكن أن تتقاطع حواف الشكل!',
          tooltip: {
            start: 'انقر لبدء رسم الخط.',
            cont: 'انقر للاستمرار في الرسم.',
            end: 'انقر على النقطة الأخيرة لإنهاء الخط.',
          },
        },
        rectangle: {
          tooltip: {
            start: 'انقر واسحب لرسم مستطيل.',
          },
        },
        simpleshape: {
          tooltip: {
            end: 'حرر الفأرة لإنهاء الرسم.',
          },
        },
      },
    },
    edit: {
      toolbar: {
        actions: {
          save: {
            title: 'حفظ التغييرات.',
            text: 'حفظ',
          },
          cancel: {
            title: 'إلغاء التعديل وإلغاء التغييرات.',
            text: 'إلغاء',
          },
        },
        buttons: {
          edit: 'تعديل الأشكال',
          editDisabled: 'لا توجد أشكال للتعديل',
          remove: 'حذف الأشكال',
          removeDisabled: 'لا توجد أشكال للحذف',
        },
      },
      handlers: {
        edit: {
          tooltip: {
            text: 'اسحب المقابض أو العلامة لتعديل الشكل.',
            subtext: 'انقر على إلغاء للتراجع عن التغييرات.',
          },
        },
        remove: {
          tooltip: {
            text: 'انقر على شكل لحذفه.',
          },
        },
      },
    },
  },
};
